export const ticiScoreList = [
  {
    Label: "TICI 0/1",
    Value: 1,
  },
  {
    Label: "TICI 2A",
    Value: 2,
  },
  {
    Label: "TICI 2B",
    Value: 3,
  },
  {
    Label: "TICI 2C",
    Value: 4,
  },
  {
    Label: "TICI 3",
    Value: 5,
  },
];
